import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./embed.css";
import wornDots from "./worn-dots.png";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const EmbedCiTPage = () => {
    const [id, setId] = useState(null);
    const query = useQuery();

    useEffect(() => {
        const queryId = query.get("id");
        if (queryId) {
            console.log(queryId);
            setId(queryId);
        }
    }, [query]);

    if (!id) return null;

    if (!["oejxdipcf4", "2p12wy7rt0", "p440xkjx75"].includes(id))
        return "Invalid url";

    const getUniName = (videoid) => {
        if (videoid === "oejxdipcf4") return "BU Law";
        if (videoid === "2p12wy7rt0") return "Texas A&M School of Law";
        if (videoid === "p440xkjx75") return "USC Gould School of Law";
    };

    const getStudentName = (videoid) => {
        if (videoid === "oejxdipcf4") return "Yuzana";
        if (videoid === "2p12wy7rt0") return "Dylan";
        if (videoid === "p440xkjx75") return "Zicheng";
    };

    return (
        <div
            style={{
                backgroundImage: `
          url(${wornDots}),
          linear-gradient(to bottom, #fefefe, #d2d5f6)
        `,
                backgroundRepeat: "repeat, no-repeat",
                backgroundSize: "auto, cover",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <nav className="cit-navbar">
                <img
                    src="https://framerusercontent.com/images/TDlXOWOObHIekCyKlgpBN0k5GlY.png?scale-down-to=512"
                    className="cit-logo"
                    alt="BU Law Logo"
                />
                <button className="cit-button">
                    <img src="support_agent_white.svg" alt="Support Icon" />
                    Support
                </button>
            </nav>

            <div className="cit-video-container">
                <style>
                    {`
            wistia-player[media-id="${id}"]:not(:defined) {
              background: center / contain no-repeat url("https://fast.wistia.com/embed/medias/${id}/swatch");
              display: block;
              filter: blur(5px);
              padding-top: 56.25%; 
            }
          `}
                </style>
                <wistia-player
                    media-id={id}
                    aspect="1.7777777777777777"
                ></wistia-player>
            </div>
            <div className="cit-page">
                <h1>Welcome {getStudentName(id)}!</h1>
                <span className="cit-description">
                    Congratulations on your admission! As you weigh your
                    options, we'd like to share a special message for you from
                    one of our alumni. In this short video, they reflect on
                    their experience at {getUniName(id)} — what brought them
                    here, what they gained during their time with us, and how it
                    has shaped their path since graduation. We hope their story
                    gives you a clearer picture of what it's like to be part of
                    the {getUniName(id)} community — and what's possible for you
                    here.
                </span>

                {/* <h2>Next Steps</h2>
                <div id="cit-markdown"></div>

                <h2>Some useful links</h2>
                <ul>
                    <li>
                        <a href="https://collegeit.org">Onboard - BU Law</a>
                    </li>
                    <li>
                        <a href="https://collegeit.org">Onboard - BU Law</a>
                    </li>
                    <li>
                        <a href="https://collegeit.org">Onboard - BU Law</a>
                    </li>
                </ul> */}
            </div>
        </div>
    );
};

export default EmbedCiTPage;
